import React, { useState, useRef, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import { generateIdCard } from "../../../api/IdCard";

import axios from "axios";
import { ToastMain, closeModal ,SweetAlertShow} from "../../master/Master";



const IDCardGenerator = () => {
  const [type, setType] = useState("");
  const [logo, setLogo] = useState(null);
  const [signature, setSignature] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [bgColor, setBgColor] = useState("#f0f0f0");
  const [headerColor, setHeaderColor] = useState("#8c57ff");
  const [headerColor1, setHeaderColor1] = useState("#ffb400");
  const [error, setError] = useState('')
  const [footerColor, setFooterColor] = useState("#343a40");
  const [name, setName] = useState("John Doe");
  const [selectedCard, setSelectedCard] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate('')
  const [] = useState();

  const cardRefs = useRef([]);

  const templates = [
    { id: "v1", name: "vertical Card 1", orientation: "vertical", type: "v1" },
    { id: "v3", name: "vertical Card 3", orientation: "vertical", type: "v3" },
    { id: "v2", name: "vertical Card 2", orientation: "vertical", type: "v2" },
    // { id: "v4", name: "vertical Card 4", orientation: "vertical", type: "v4" },
    { id: "v6", name: "vertical Card 6", orientation: "vertical", type: "v6" },
    { id: "v7", name: "vertical Card 7", orientation: "vertical", type: "v7" },
    { id: "v8", name: "vertical Card 8", orientation: "vertical", type: "v8" },
    { id: "v9", name: "vertical Card 9", orientation: "vertical", type: "v9" },
    { id: "v10", name: "vertical Card 10", orientation: "vertical", type: "v10" },
    { id: "h1", name: "horizontal Card 1", orientation: "horizontal", type: "h1" },
    { id: "h2", name: " horizontal Card 2", orientation: "horizontal", type: "h2" },
    { id: "h3", name: " horizontal Card 3", orientation: "horizontal", type: "h3" },
    { id: "h4", name: " horizontal Card 4", orientation: "horizontal", type: "h4" },
    { id: "h5", name: " horizontal Card 5", orientation: "horizontal", type: "h5" },
    { id: "h6", name: " horizontal Card 6", orientation: "horizontal", type: "h6" },
  ];

  const FIELD_MAP = {
    student: [
      { label: "ID", key: "{registration_no}" },
      { label: "Phone", key: "{student_phone}" },
      { label: "Class", key: "{batch_name}" },
      { label: "Father's", key: "{father_name}" },
      { label: "Address", key: "{student_village}" },
    ],
    teacher: [
      { label: "ID", key: "{staff_id}" },
      { label: "Phone", key: "{staff_phone}" },
      { label: "Email", key: "{staff_email}" },
      { label: "Designation", key: "{designation}" },
      { label: "Address", key: "{staff_address}" },
    ],
  };



  useEffect(() => {
    if (type) {
      const savedCard = localStorage.getItem(`selectedCard_${type}`);
      if (savedCard) {
        setSelectedCard(savedCard); // direct string use karo
      } else {
        setSelectedCard("");
      }
    }
  }, [type]);




  const handleSubmit = async () => {
    if (!selectedCard) {
      alert("Please select a card first.");
      return;
    }
    setLoading(true);
    localStorage.setItem(`selectedCard_${type}`, selectedCard);

    try {
      const formData = new FormData();

      const selectedTemplate = templates.find((tpl) => tpl.id === selectedCard);
      if (!selectedTemplate) {
        alert("Invalid template selected");
        setLoading(false);
        return;
      }

      const cardHTML = cardRefs.current[selectedCard]?.innerHTML || "";

      // ✅ Fix: title me horizontal / vertical bhejna
      formData.append("title", selectedTemplate.orientation);
      formData.append("type", type === "teacher" ? "staff" : "student");
      formData.append("card_html", cardHTML);

      if (logo) formData.append("logo", logo);
      if (signature) formData.append("signature", signature);

      const response = await generateIdCard(formData);

      if (response?.data?.success) {
        // ToastMain.fire({
        //   icon: "success",
        //   title: response?.data?.message || "Card Saved Successfully!",
        // });

        SweetAlertShow('success','Successfully',response?.data?.message)
      } else {
        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || "Something Went Wrong!",
        }).then(() => {
          navigate('/idcard');
        })
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Went Wrong!",
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ??  error?.response?.message ?? error?.message )
    } finally {
      setLoading(false);
    }
  };
  const VerticalCard = ({
    isSelected,
    bgColor,
    headerColor,
    footerColor,
    logo,
    profile_picture,
    signature,

  }) => {
    return (
      <div
        className={`id-card-preview border position-relative`}
        style={{
          width: "260px",
          height: "400px",
          backgroundColor: bgColor,
          borderRadius: "10px",
          overflow: "hidden",
          border: isSelected ? "3px solid #007bff" : "1px solid #ccc",
          // boxShadow: isSelected ? "0px 4px 12px rgba(0,123,255,0.5)" : "none",
          transition: "0.3s",
        }}
      >
        {/* Header */}
       <div
  style={{
    backgroundColor: "rgb(140, 87, 255)",
    color: "#fff",
    padding: "5px 10px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100px",
    position: "relative",
  }}
>
  {/* Left side Logo */}
  <img
    src="{logo}"
    alt="logo"
    style={{
      height: "50px",
      width: "50px",
      objectFit: "contain",
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
    }}
  />

  {/* School name + address stacked */}
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <h6 className="mb-0" style={{ fontWeight: "bold"  , fontSize:'10px'}}>
      {"{school_name}"}
    </h6>
    <small style={{ fontSize:'8px' , color:'black' }}>{"{school_address}"}</small>
  </div>

  {/* Student Photo overlapping header */}
  <div
    style={{
      position: "absolute",
      bottom: "-60px",
      left: "50%",
      transform: "translateX(-50%)",
    }}
  >
    <img
      src="{profile_picture}"
      alt="profile"
      className="rounded-circle border border-3 border-white shadow"
      style={{
        width: "90px",
        height: "90px",
        objectFit: "cover",
        borderRadius: "50%",
      }}
    />
  </div>
</div>


        <div className="p-3 text-dark" style={{ marginTop: "60px" }}>
          <h6 className="fw-bold text-center">
            {type === "student" ? "{student_name}" : "{staff_name}"}
          </h6>
          {FIELD_MAP[type]?.map((field, idx) => (
            <div className="row small mb-1" key={idx}>
              <div className="col-4 fw-bold">{field.label}:</div>
              <div className="col-8">{field.key}</div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div
          style={{
            backgroundColor: footerColor,
            color: "#fff",
            padding: "8px 10px",
            position: "absolute",
            bottom: 0,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ flex: 1, textAlign: "center" }}>
            <small>{'{school_number}'}</small>
          </div>


          <div style={{ marginLeft: "auto" }}>
            <img
              src={"{signature}"}
              alt="signature"
              style={{ height: "25px", objectFit: "contain" }}
            />
          </div>

        </div>

      </div>
    );
  };
  const VerticalCard2 = ({
    isSelected,
    bgColor,
    headerColor1,
    footerColor,
    logo,
    photo,
    signature,
    profile_picture

  }) => {
    return (
      <div
        className={`id-card-preview border position-relative`}
        style={{
          width: "260px",
          height: "400px",
          backgroundColor: bgColor,
          borderRadius: "10px",
          overflow: "hidden",
          border: isSelected ? "3px solid #007bff" : "1px solid #ccc",
          // boxShadow: isSelected ? "0px 4px 12px rgba(0,123,255,0.5)" : "none",
          transition: "0.3s",
        }}
      >
        {/* Header */}
        <div
  style={{
    backgroundColor: "rgb(255, 180, 0)",
    color: "#fff",
    padding: "5px 10px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100px",
    position: "relative",
  }}
>
  {/* Left side Logo */}
  <img
    src="{logo}"
    alt="logo"
    style={{
      height: "50px",
      width: "50px",
      objectFit: "contain",
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
    }}
  />

  {/* School name + address stacked */}
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <h6 className="mb-0" style={{ fontWeight: "bold"  , fontSize:'10px'}}>
      {"{school_name}"}
    </h6>
    <small style={{ fontSize:'8px' , color:'black' }}>{"{school_address}"}</small>
  </div>

  {/* Student Photo overlapping header */}
  <div
    style={{
      position: "absolute",
      bottom: "-60px",
      left: "50%",
      transform: "translateX(-50%)",
    }}
  >
    <img
      src="{profile_picture}"
      alt="profile"
      className="rounded-circle border border-3 border-white shadow"
      style={{
        width: "90px",
        height: "90px",
        objectFit: "cover",
        borderRadius: "50%",
      }}
    />
  </div>
</div>

        {/* Details */}
        <div className="p-3 text-dark" style={{ marginTop: "60px" }}>
          <h6 className="fw-bold text-center">
            {type === "student" ? "{student_name}" : "{staff_name}"}
          </h6>
          {FIELD_MAP[type]?.map((field, idx) => (
            <div className="row small mb-1" key={idx}>
              <div className="col-4 fw-bold">{field.label}:</div>
              <div className="col-8">{field.key}</div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div
          style={{
            backgroundColor: footerColor,
            color: "#fff",
            padding: "8px 10px",
            position: "absolute",
            bottom: 0,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ flex: 1, textAlign: "center" }}>
            <small>{'{school_number}'}</small>
          </div>


          <div style={{ marginLeft: "auto" }}>
            <img
              src={"{signature}"}
              alt="signature"
              style={{ height: "25px", objectFit: "contain" }}
            />
          </div>

        </div>
      </div>
    );
  };
  const VerticalCard3 = ({
    isSelected,
    bgColor,
    headerColor1,
    footerColor,
    logo,
    photo,
    signature,
    profile_picture,
  }) => {
    return (
      <div
        className={`id-card-preview border position-relative`}
        style={{
          width: "260px",
          height: "400px",
          backgroundColor: bgColor,
          borderRadius: "10px",
          overflow: "hidden",
          border: isSelected ? "3px solid #007bff" : "1px solid #ccc",
          // boxShadow: isSelected ? "0px 4px 12px rgba(0,123,255,0.5)" : "none",
          transition: "0.3s",
        }}
      >
        {/* Header */}
        <div
  style={{
    backgroundColor: "rgb(88 255 241)",
    color: "#fff",
    padding: "5px 10px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100px",
    position: "relative",
  }}
>
  {/* Left side Logo */}
  <img
    src="{logo}"
    alt="logo"
    style={{
      height: "50px",
      width: "50px",
      objectFit: "contain",
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
    }}
  />

  {/* School name + address stacked */}
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <h6 className="mb-0" style={{ fontWeight: "bold"  , fontSize:'10px'}}>
      {"{school_name}"}
    </h6>
    <small style={{ fontSize:'8px' , color:'black' }}>{"{school_address}"}</small>
  </div>

  {/* Student Photo overlapping header */}
  <div
    style={{
      position: "absolute",
      bottom: "-60px",
      left: "50%",
      transform: "translateX(-50%)",
    }}
  >
    <img
      src="{profile_picture}"
      alt="profile"
      className="rounded-circle border border-3 border-white shadow"
      style={{
        width: "90px",
        height: "90px",
        objectFit: "cover",
        borderRadius: "50%",
      }}
    />
  </div>
</div>

        {/* Details */}
        <div className="p-3 text-dark" style={{ marginTop: "60px" }}>
          <h6 className="fw-bold text-center">
            {type === "student" ? "{student_name}" : "{staff_name}"}
          </h6>
          {FIELD_MAP[type]?.map((field, idx) => (
            <div className="row small mb-1" key={idx}>
              <div className="col-4 fw-bold">{field.label}:</div>
              <div className="col-8">{field.key}</div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div
          style={{
            backgroundColor: footerColor,
            color: "#fff",
            padding: "8px 10px",
            position: "absolute",
            bottom: 0,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ flex: 1, textAlign: "center" , fontSize:'10px' }}>
            <small>{'{school_number}'}</small>
          </div>


          <div style={{ marginLeft: "auto" }}>
            <img
              src={"{signature}"}
              alt="signature"
              style={{ height: "25px", objectFit: "contain" }}
            />
          </div>

        </div>
      </div>
    );
  };
  const VerticalCard6 = ({
    isSelected,
    bgColor,
    headerColor,
    footerColor,
    logo,
    photo,
    profile_picture,
    signature,

  }) => {
    return (
      <div
        className={`id-card-preview border position-relative`}
        style={{
          width: "260px",
          height: "400px",
          backgroundColor: bgColor,
          borderRadius: "10px",
          overflow: "hidden",
          border: isSelected ? "3px solid #007bff" : "1px solid #ccc",
          // boxShadow: isSelected ? "0px 4px 12px rgba(0,123,255,0.5)" : "none",
          transition: "0.3s",
        }}
      >
        {/* Header */}
        <div
  style={{
    backgroundColor: "rgb(88 255 241)",
    color: "#fff",
    padding: "5px 10px",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100px",
    position: "relative",
  }}
>
  {/* Left side Logo */}
  <img
    src="{logo}"
    alt="logo"
    style={{
      height: "50px",
      width: "50px",
      objectFit: "contain",
      position: "absolute",
      left: "10px",
      top: "50%",
      transform: "translateY(-50%)",
    }}
  />

  {/* School name + address stacked */}
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <h6 className="mb-0" style={{ fontWeight: "bold"  , fontSize:'10px'}}>
      {"{school_name}"}
    </h6>
    <small style={{ fontSize:'8px' , color:'black' }}>{"{school_address}"}</small>
  </div>

  {/* Student Photo overlapping header */}
  <div
    style={{
      position: "absolute",
      bottom: "-60px",
      left: "50%",
      transform: "translateX(-50%)",
    }}
  >
    <img
      src="{profile_picture}"
      alt="profile"
      className="rounded-circle border border-3 border-white shadow"
      style={{
        width: "90px",
        height: "90px",
        objectFit: "cover",
        borderRadius: "50%",
      }}
    />
  </div>
</div>


        {/* Details */}
        {/* <div className="p-3 text-dark" style={{ marginTop: "60px" }}>
          <h6 className="fw-bold text-center">{'{student_name}'}</h6>
          <div className="row small mb-1">
            <div className="col-4 fw-bold">ID:</div>
            <div className="col-8">{'{school_reg_no}'}</div>
          </div>
          <div className="row small mb-1">
            <div className="col-4 fw-bold">Phone:</div>
            <div className="col-8">{'{student_phone}'}</div>
          </div>
          <div className="row small mb-1">
            <div className="col-4 fw-bold">Class:</div>
            <div className="col-8">{'{batch_name}'}</div>
          </div>
          <div className="row small mb-1">
            <div className="col-4 fw-bold">Father's</div>
            <div className="col-8">{'{father_name}'}</div>
          </div>
          <div className="row small mb-1">
            <div className="col-4 fw-bold">Address:</div>
            <div className="col-8">{'{student_village}'}</div>
          </div>
        </div> */}

        <div className="p-3 text-dark" style={{ marginTop: "60px" }}>
          <h6 className="fw-bold text-center">
            {type === "student" ? "{student_name}" : "{staff_name}"}
          </h6>
          {FIELD_MAP[type]?.map((field, idx) => (
            <div className="row small mb-1" key={idx}>
              <div className="col-4 fw-bold">{field.label}:</div>
              <div className="col-8">{field.key}</div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div
          style={{
            backgroundColor: 'rgb(88 255 241)',
            color: "#080808ff",
            padding: "8px 10px",
            position: "absolute",
            bottom: 0,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ flex: 1, textAlign: "center" }}>
            <small>{'{school_number}'}</small>
          </div>


          <div style={{ marginLeft: "auto" }}>
            <img
              src={"{signature}"}
              alt="signature"
              style={{ height: "25px", objectFit: "contain" }}
            />
          </div>

        </div>
      </div>
    );
  };
  const VerticalCard7 = ({
    isSelected,
    bgColor,
    logo,
    profile_picture,
    signature,
    // type,
    // FIELD_MAP,
    tpl, // data object with student/staff fields
  }) => {
    return (
      <>
        {/* Inline CSS for new vertical design */}
        <style>{`
        :root {
          --primary: #c62828;
          --teal: #2ca6a6;
        }
        .id-card7 {
          width: 54mm;
          height: 85.6mm;
          border-radius: 6px;
          background: ${bgColor || "#fff"};
          box-shadow: ${isSelected ? "0 4px 14px rgba(0, 0, 0, .35)" : "0 4px 14px rgba(0, 0, 0, .25)"};
          margin: auto;
          position: relative;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }
        .card-header7 {
          display: flex;
          align-items: center;
          gap: 3mm;
          padding: 2mm;
          border-bottom: 1px solid #000;
        }
        .card-header7 .logo {
          width: 12mm;
          height: 12mm;
          border-radius: 50%;
          background: #fff;
          overflow: hidden;
          border: 1px solid #ccc;
          flex-shrink: 0;
        }
          logo7{
          height:'50px';
          width:'50px';
          }
        .card-header7 .logo img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .school-info7 { flex: 1; }
        .school-name7 {
          font-weight: 700;
          font-size: 10px;
          line-height: 1.2;
        }
        .school-address7 {
          font-size: 8px;
          opacity: 0.9;
        }
        .photo-frame7 {
          width: 40%;
          margin: 2mm auto;
          background: var(--teal);
          padding: 0.8mm;
          border-radius: 4px;
        }
        .photo-frame7 img {
          width: 100%;
          height: 22mm;
          object-fit: cover;
          border-radius: 3px;
        }
        .details7 {
          padding: 2mm 3mm;
          flex: 1;
        }
        .student-name7 {
          background: var(--teal);
          color: #fff;
          font-weight: 700;
          font-size: 3mm;
          padding: 0.8mm;
          border-radius: 3px;
          text-align: center;
          margin-bottom: 5px;
          margin-top: -12px;
        }
        .id-no7 {
          text-align: center;
          font-size: 2.5mm;
          font-weight: 600;
          margin-bottom: 2mm;
          color: #333;
        }
        .info-row7 {
          display: flex;
          justify-content: space-between;
          font-size: 8px;
          padding: 0.6mm 0;
          border-bottom: 0.2mm dashed #ddd;
        }
        .info-row7:last-child7 { border: none; }
        .info-label7 {
          font-weight: 600;
          color: #333;
        }
        .info-value7 {
          color: #0b57d0;
          text-align: right;
          flex: 1;
          padding-left: 2mm;
        }
        .card-footer7 {
          border-top: 1px solid #000;
          padding: 1.5mm 3mm;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .phone-pill7 {
          background: #fff;
          color: var(--primary);
          font-weight: 700;
          padding: 0.5mm 2mm;
          border-radius: 3mm;
          font-size: 2.3mm;
          border: 1px solid var(--primary);
        }
        .signature7 {
          text-align: center;
          font-size: 2.2mm;
          color: #333;
        }
      `}</style>

        <div className="id-card7">
          {/* Header */}
          <div className="card-header7">
            <div className="logo">
              <img src={"{logo}"} alt="School Logo" />
            </div>
            <div className="school-info7">
              <div className="school-name7">{tpl?.school_name || "{school_name}"}</div>
              <div className="school-address7">{tpl?.school_address || "{school_address}"}</div>
            </div>
          </div>

          {/* Student Photo */}
          <div className="photo-frame7">
            <img
              src={profile_picture || tpl?.profile_picture || "{profile_picture}"}
              alt="Student"
            />
          </div>

          {/* Details */}
          <div className="details7">
            <div className="student-name7">
              {type === "student" ? tpl?.student_name || "{student_name}" : tpl?.staff_name || "{staff_name}"}
            </div>
            {/* <div className="id-no">ID: {tpl?.id_no || "{id_no}"}</div> */}

            {FIELD_MAP[type]?.map((field, idx) => (
              <div className="info-row7" key={idx}>
                <div className="info-label7">{field.label}</div>
                <div className="info-value7">{field.key}</div>
              </div>
            ))}
          </div>

          {/* Footer */}
          <div className="card-footer7">
            <div className="phone-pill7">{"{school_number}"}</div>
            <div className="signature7">
              <img src={"{signature}"} alt="signature" style={{ height: "20px", objectFit: "contain" }} />
            </div>
          </div>
        </div>
      </>
    );
  };

  const VerticalCard8 = ({
    isSelected,
    bgColor,
    logo,
    profile_picture,
    signature,
    // type,
    // FIELD_MAP,
    // tpl, // data object with student/staff fields
  }) => {
    return (
      <>
        <style>{`
        .id-card8 {
          width: 210px;      /* ✅ Actual ID width */
          height: 340px;     /* ✅ Actual ID height */
          border-radius: 10px;
          box-shadow: ${isSelected ? "0 6px 18px rgba(0,0,0,0.35)" : "0 4px 12px rgba(0,0,0,0.2)"};
          overflow: hidden;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          background-color: ${bgColor || "#fff"};
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .header8 {
          background: linear-gradient(180deg, #d00000, #6b0000);
          color: #fff;
          text-align: center;
          padding: 8px 6px;
        }
        .header8 img {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-bottom: 4px;
          border: 1.5px solid #fff;
          background: #fff;
        }
        .header8 h5 {
          font-size: 11px;
          font-weight: 700;
          margin: 0;
          line-height: 1.1;
        }
        .header8 p {
          font-size: 8.5px;
          margin: 1px 0;
        }
        .session8 {
          color: yellow;
          font-weight: bold;
          font-size: 9px;
          margin-top: 3px;
        }

        .photo-section8 {
          text-align: center;
          padding: 6px 0;
        }
        .photo-section8 img {
          width: 70px;
          height: 85px;
          object-fit: cover;
          border: 2px solid #222;
          border-radius: 5px;
        }

        .info-section8 {
          padding: 4px 8px;
          text-align: center;
          margin-top: -20px;
        }
        .info-section8 h6 {
          font-size: 9px;
          font-weight: bold;
          margin-bottom: 3px;
          color: #444;
        }
        .info-section8 h5 {
          font-size: 12px;
          font-weight: bold;
          margin: 4px 0;
          color: #d00000;
          text-transform: uppercase;
        }
        .info-section8 p {
          font-size: 8.5px;
          margin: 2px 0;
          line-height: 1.2;
        }

        .signature8 {
          font-size: 8px;
          font-weight: bold;
          text-align: right;
          padding: 0 10px 15px 0;
          color: #333;
        }
        .line8 {
          height: 8px;
          background: black;
          transform: skewY(355deg);
        }
      `}</style>

        <div className="id-card8">
          {/* Header */}
          <div className="header8">
            <img src={"{logo}"} alt="School Logo" />
            {/* <h5>{ "SENIOR SECONDARY"}</h5> */}
            <h5 style={{ color: "yellow" }}>{"{school_name}"}</h5>
            <p>{"{school_address}"}</p>
            <p>{"{school_number}"}</p>
            {/* <p>{"Contact: 0000000000"}</p> */}
            {/* <p className="session8">Session: {tpl?.session || "2024-25"}</p> */}
          </div>

          {/* Photo */}
          <div className="photo-section8">
            <img
              src={"{profile_picture}"}
              alt="Student"
            />
          </div>

          {/* Info Section */}
          <div className="info-section8">
            {/* <h6>{tpl?.class_name ? `Class: ${tpl.class_name}` : "{class}"}</h6> */}
            <h5>
              {type === "student"
                ? "{student_name}"
                : "{staff_name}"}
            </h5>

            {FIELD_MAP[type]?.map((field, idx) => (
              <p key={idx}>
                <strong>{field.label}:</strong> {[field.key] || "-"}
              </p>
            ))}
          </div>

          {/* Footer */}
          <div>
           {/* <div  style={{ borderTop:'top', borderColor:'black',borderWidth:'2px' }}>
            <small className="number_section">9306487930 9812908671</small>
           </div> */}
            <div className="signature8">

              <img
                src={"{signature}"}
                alt="signature"
                style={{ height: "20px", objectFit: "contain" }}
              />

            </div>
            <div className="line8 w-100"></div>
          </div>
        </div>
      </>
    );
  };

  const VerticalCard9 = ({
    isSelected,
    bgColor,
    logo,
    profile_picture,
    signature,
    // type,
    // FIELD_MAP,
    school_name,
    school_address,
    staff_name,
    student_name,
  }) => {
    return (
      <>
        <style>{`
        .id-card8 {
          width: 230px; /* Card width similar to image */
          height: 360px; /* Card height similar to image */
          border-radius: 14px;
          box-shadow: ${isSelected ? "0 6px 18px rgba(0,0,0,0.40)" : "0 3px 10px rgba(0,0,0,0.17)"};
          overflow: hidden;
          font-family: 'Montserrat', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          background: #fff;
          display: flex;
          flex-direction: column;
        }
        .wave-header {
          position: relative;
          height: 82px;
          background: #09223b;
        }
        .header-wave-svg {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          z-index: 2;
        }
        .wave-header-content {
          position: absolute;
          top: 5px;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          z-index: 3;
        }
        .id-logo {
          width: 38px;
          height: 38px;
          background: #fff;
          border-radius: 7px;
          object-fit: contain;
          margin-bottom: 2px;
          margin-top: 8px;
        }
        .school-text {
          color: #fff;
          font-weight: 700;
          font-size: 8  px;
          letter-spacing: 1px;
          margin: 0;
        }
        .school-address {
          color: #fff;
          font-size: 9px;
          margin-top: 2px;
        }
        .profile-circle {
          position: absolute;
          left: 50%;
          bottom: -85px;
          transform: translateX(-50%);
          width: 84px;
          height: 84px;
          padding: 3px;
          background: #fff;
          border-radius: 50%;
          z-index: 5;
          border: 3px dotted #09223b;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .profile-pic-img {
          width: 74px;
          height: 74px;
          border-radius: 50%;
          object-fit: cover;
          border: 3px solid #ed222e;
          box-shadow: 0 1px 6px rgba(237,34,46,0.13);
        }
        .main-content8 {
          margin-top: 54px;
          text-align: center;
          padding: 16px 13px 2px 13px;
          flex: 1 1;
        }
        .id-bar {
          background: linear-gradient(90deg, #ed222e 60%, #fff 100%);
          border-radius: 12px;
          padding: 0px 0;
          margin: 20px auto 6px auto;
          width: 92%;
          font-size: 13px;
          font-weight: bold;
          color: #fff !important;
          letter-spacing: 1px;
          box-shadow: 0 1px 3px rgba(100,0,0,0.09);
        }
        .info-list8 {
          text-align: left;
          margin-top: 7px;
          font-size: 10.3px;
          color: #222;
        }
        .info-list8 .label {
          font-weight: 700;
          color: #09223b;
        }
        .signature-bar {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding-right: 20px;
          height: 34px;
          margin-bottom: 1px;
        }
        .signature-bar img {
          height: 22px;
          object-fit: contain;
        }
        .curve-footer {
          position: relative;
          height: 36px;
          background: #09223b;
        }
        .curve-footer-svg {
          position: absolute;
          top: -7px;
          left: 0;
          width: 100%;
        }
          small.number_again {
    position: absolute;
    color: white;
    z-index: 2;
    font-size: 10px;
    left: 53px;
    top: 12px;
}
    .student_name{
    font-size:10px;
    }
      `}</style>

        <div className="id-card8">
          <div className="wave-header">
            <svg className="header-wave-svg" viewBox="0 0 230 82" height="82" width="230">
              <path d="M0,0 Q80,60 230,0 L230,82 L0,82 Z" fill="#ed222e" />
              <path d="M0,0 Q120,70 230,0 L230,46 L0,54 Z" fill="#fff" opacity="0.8" />
            </svg>
            <div className="wave-header-content">
              <img src={"{logo}"} alt="School Logo" className="id-logo" />
              <span className="school-text">{"{school_name}"}</span>
              <span className="school-address">{"{school_address}"}</span>
            </div>
            <div className="profile-circle">
              <img src={"{profile_picture}"} alt="profile" className="profile-pic-img" />
            </div>
          </div>

          <div className="main-content8">
            <div className="id-bar">
              <h5 className="student_name">
                {type === "student"
                  ? "{student_name}"
                  : "{staff_name}"}
              </h5>
            </div>
            <div className="info-list8">
              {FIELD_MAP[type]?.map((field, idx) => (
                <div key={idx}>
                  <span className="label">{field.label}:</span>{" "}
                  <span>{field.key || "-"}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="signature-bar">

            <img src={"{signature}"} alt="signature" />

          </div>
          <div className="curve-footer">
            <small className="number_again">{"{school_number}"}</small>
            <svg className="curve-footer-svg" viewBox="0 0 230 36" width="230" height="36">
              <path d="M0,25 Q120,7 230,25 L230,36 L0,36 Z" fill="#ed222e" />
            </svg>
          </div>
        </div>
      </>
    );
  };
  const VerticalCardPro = ({
    isSelected,
    bgColor = "#fff",
    logo,
    profile_picture,
    signature,
    // type,
    // FIELD_MAP,
    school_name = "",
    school_address = "",
    staff_name = "",
    student_name = "",
  }) => {
    return (
      <>
        <style>{`
        .pro-id-card {
          width: 250px;
          height: 370px;
          border-radius: 18px;
          overflow: hidden;
          font-family: 'Montserrat', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          background: ${bgColor};
          display: flex;
          flex-direction: column;
          box-shadow: ${isSelected
            ? "0 8px 28px rgba(0,35,99,0.23), 0 1.5px 4px rgba(0,0,0,0.11)"
            : "0 2px 8px rgba(0,0,0,0.10)"};
          border: 2px solid ${isSelected ? "#326dee" : "#f1f3f6"};
          position: relative;
        }
        .pro-header {
          position: relative;
          height: 92px;
          background: linear-gradient(120deg, #1c274c 65%, #295ab5 100%);
          color: #fff;
          overflow: hidden;
          z-index: 2;
        }
        .svg-wave {
          position: absolute;
          left: 0;
          top: 0; width: 100%;
        }
        .pro-header-content {
          position: relative;
          z-index: 2;
          padding-top: 0px;
          text-align: center;
        }
        .pro-logo {
          width: 38px;
          height: 38px;
          background: #fff;
          border-radius: 8px;
          object-fit: contain;
          box-shadow: 0 1.5px 7px rgba(50,110,222,0.09);
          margin-bottom: 2px;
        }
        .pro-school-text {
          font-size: 9px;
          letter-spacing: 1px;
          font-weight: 800;
          margin: 2px 0 0 0;
        }
        .pro-school-address {
          font-size: 11px;
          color: #f4f9fd;
          opacity: 0.92;
          line-height: 1.1;
          margin-top: 1px;
          font-weight: 500;
          text-align: center;
          
        }
        .pro-profile-wrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          position: relative;
          z-index: 5;
        }
        .pro-profile-circle {
          margin-top: -44px; /* Overlap the header */
          background: linear-gradient(120deg, #e7edfc 60%, #296be7 120%);
          box-shadow: 0 1.5px 9px #295ab529;
          border: 3px solid #fff;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          display: flex;
          align-items: center; 
          justify-content: center;
          z-index: 6;
        }
        .pro-profile-pic {
          width: 80px;
          height: 80px;
          object-fit: cover;
          border-radius: 50%;
          border: 2.5px solid #ffffff;
          box-shadow: 0 1.5px 8px rgba(50,90,220,0.07);
        }
        .pro-card-content {
          margin-top: -23px;
          padding: 12px 17px 1px 17px;
          flex: 1 1;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }
        .pro-id-title {
          display: block;
          margin: 19px auto 13px auto;
          width: 95%;
          background: linear-gradient(90deg, #297be5 70%, #dfeffd 100%);
          border-radius: 13px;
          font-size: 8.5px;
          letter-spacing: 1.1px;
          font-weight: 700;
          color: #fff;
          padding: 7px 0 6px 0;
          box-shadow: 0 2px 7px #295ab510;
          text-align: center;
        }
        .pro-details-list {
          margin-top: 4px;
          font-size: 11.5px;
          color: #1d284e;
        }
        .pro-details-list .label {
          font-weight: 600;
          color: #327fff;
          letter-spacing: .18px;
          min-width: 62px;
          display: inline-block;
        }
        .pro-sign-bar {
          padding: 0 18px 11px 0;
          margin-top: 9px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 10px;
        }
        .pro-sign-bar img {
          height: 22px;
          object-fit: contain;
        }
          small.number {
    position: absolute;
    font-size: 13px;
    left: 47px;
    top: 19px;
}
        .pro-footer {
          background: linear-gradient(100deg, #295ab5 35%, #1c274c 95%);
          position: relative;
          height: 41px;
          overflow: hidden;
        }
        .pro-footer-svg {
          position: absolute;
          bottom: -1px;
          left: 0;
          width: 100%;
        }
        `}
        </style>
        <div className="pro-id-card">
          {/* Header with logo/name/address */}
          <div className="pro-header">
            <svg className="svg-wave" viewBox="0 0 250 92" width="250" height="92">
              <path d="M0,0 Q90,65 250,0 L250,92 L0,92 Z" fill="#297be5" />
              <path d="M0,0 Q120,85 250,0 L250,57 L0,79 Z" fill="#f7fafc" opacity="0.22" />
            </svg>
            <div className="pro-header-content">
              <img src={"{logo}"} alt="School Logo" className="pro-logo" />
              <div className="pro-school-text">{"{school_name}"}</div>
              {/* <div className="pro-school-address">{"{school_address}"}</div> */}
            </div>
          </div>

          {/* Centered profile circle, overlapping header */}
          <div className="pro-profile-wrapper">
            <div className="pro-profile-circle">
              <img src={"{profile_picture}"} alt="profile" className="pro-profile-pic" />
            </div>
          </div>

          {/* Content below */}
          <div className="pro-card-content">
            <span className="pro-id-title">
              {type === "student" ? "{student_name}" : "{staff_name}"}
            </span>
            <div className="pro-details-list">
              {FIELD_MAP?.[type]?.map((field, idx) => (
                <div key={idx}>
                  <span className="label">{field.label}:</span> <span>{field.key || '-'}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Signature and Footer */}
          <div className="pro-sign-bar">

            <img src={"{signature}"} alt="signature" />

          </div>
          <div className="pro-footer">
            <svg className="pro-footer-svg" viewBox="0 0 250 41" height="41" width="250">
              <path d="M0,23 Q120,3 250,27 L250,41 L0,41 Z" fill="#eaefff" />
            </svg>
            <div className="pro-school-address">{"{school_address}"}</div>
            <small className="number">{"{school_number}"}</small>
          </div>
        </div>
      </>
    );
  };












  // ---------------- Horizontal Card (only this block renders horizontal layout) ----------------
  const HorizontalCard = ({
    isSelected,
    bgColor,
    headerColor,
    footerColor,
    logo,
    photo,
    signature,
    name,
    profile_picture,
  }) => {
    return (
      <div
        className="id-card-preview border position-relative"
        style={{
          width: "400px",
          height: "250px",
          backgroundColor: bgColor,
          borderRadius: "10px",
          overflow: "hidden",
          border: isSelected ? "3px solid #007bff" : "1px solid #ccc",
          // boxShadow: isSelected ? "0px 4px 12px rgba(0,123,255,0.5)" : "none",
          transition: "0.3s",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
         <div
  style={{
    backgroundColor: headerColor1,
    color: "#fff",
    padding: "6px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center", // if you want the whole header centered horizontally
    gap: "12px",
  }}
>
  <img
    src={"{logo}"} // <- pass variable, not string
    alt="logo"
    style={{
      height: "35px",
      width: "35px",
      objectFit: "contain",
    }}
  />

  {/* Column containing school name and phone numbers */}
  <div
    className="d-flex flex-column"
    style={{
      alignItems: "flex-start", // keep text left-aligned
      lineHeight: 1.1,
    }}
  >
    <h6
      className="mb-0 fw-bold text-uppercase"
      style={{ fontSize: "12px" }}
    >
      {"{school_name}"}
    </h6>

    <small style={{ fontSize: "11px", opacity: 0.95 }}>
      {"{school_number}"}
    </small>
  </div>
</div>

        {/* Photo + Details */}
        <div
          className="flex-grow-1 d-flex"
          style={{ padding: "12px", gap: "15px" }}
        >
          {/* Left Side: Photo + Name */}
          <div
            className="d-flex flex-column align-items-center justify-content-start"
            style={{ minWidth: "110px" }}
          >
            <img
              src={"{profile_picture}"}
              alt="profile"
              className="rounded-circle border border-3 border-white shadow"
              style={{
                width: "90px",
                height: "90px",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
            <h6
              className="fw-bold text-center"
              style={{ fontSize: "14px", margin: 0 }}
            >
              {type === "student" ? "{student_name}" : "{staff_name}"}
            </h6>
          </div>

          {/* Right Side: Details */}
          <div className="flex-grow-1 small d-flex flex-column justify-content-center">
            {FIELD_MAP[type]?.map((field, idx) => (
              <div className="d-flex mb-1" key={idx}>
                <div className="fw-bold me-2" style={{ minWidth: "70px" }}>
                  {field.label}:
                </div>
                <div>{field.key}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
            backgroundColor: footerColor,
            color: "#fff",
            padding: "8px 10px",
            position: "absolute",
            bottom: 0,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Center Address */}
          <div style={{ flex: 1, textAlign: "center", fontSize:'5px' }}>
            <small>{'{school_address}'}</small>
          </div>

          {/* Signature in right corner (inside same bg) */}

          <div style={{ marginLeft: "auto" }}>
            <img
              src={"{signature}"}
              alt="signature"
              style={{ height: "25px", objectFit: "contain" }}
            />
          </div>

        </div>

      </div>
    );
  };
  const HorizontalCard2 = ({
    isSelected,
    bgColor,
    headerColor1,
    footerColor,
    logo,
    photo,
    signature,
    name,
    profile_picture,
  }) => {
    return (
      <div
        className="id-card-preview border position-relative"
        style={{
          width: "400px",
          height: "250px",
          backgroundColor: bgColor,
          borderRadius: "10px",
          overflow: "hidden",
          border: isSelected ? "3px solid #007bff" : "1px solid #ccc",
          // boxShadow: isSelected ? "0px 4px 12px rgba(0,123,255,0.5)" : "none",
          transition: "0.3s",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
       <div
  style={{
    backgroundColor: 'rgb(238 ,34, 47)',
    color: "#fff",
    padding: "6px 10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center", // if you want the whole header centered horizontally
    gap: "12px",
  }}
>
  <img
    src={"{logo}"} // <- pass variable, not string
    alt="logo"
    style={{
      height: "35px",
      width: "35px",
      objectFit: "contain",
    }}
  />

  {/* Column containing school name and phone numbers */}
  <div
    className="d-flex flex-column"
    style={{
      alignItems: "flex-start", // keep text left-aligned
      lineHeight: 1.1,
    }}
  >
    <h6
      className="mb-0 fw-bold text-uppercase"
      style={{ fontSize: "12px" }}
    >
      {"{school_name}"}
    </h6>

    <small style={{ fontSize: "11px", opacity: 0.95 }}>
      {"{school_number}"}
    </small>
  </div>
</div>


        {/* Photo + Details */}
        <div
          className="flex-grow-1 d-flex"
          style={{ padding: "12px", gap: "15px" }}
        >
          {/* Left Side: Photo + Name */}
          <div
            className="d-flex flex-column align-items-center justify-content-start"
            style={{ minWidth: "110px" }}
          >
            <img
              src={"{profile_picture}"}
              alt="profile"
              className="rounded-circle border border-3 border-white shadow"
              style={{
                width: "90px",
                height: "90px",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
            <h6
              className="fw-bold text-center"
              style={{ fontSize: "14px", margin: 0 }}
            >
              {type === "student" ? "{student_name}" : "{staff_name}"}
            </h6>
          </div>

          {/* Right Side: Details */}
          <div className="flex-grow-1 small d-flex flex-column justify-content-center">
            {FIELD_MAP[type]?.map((field, idx) => (
              <div className="d-flex mb-1" key={idx}>
                <div className="fw-bold me-2" style={{ minWidth: "70px" }}>
                  {field.label}:
                </div>
                <div>{field.key}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div
          style={{
                backgroundColor: 'rgb(9 ,34, 59)',
            color: "#fff",
            padding: "8px 10px",
            position: "absolute",
            bottom: 0,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Center Address */}
          <div style={{ flex: 1, textAlign: "center" }}>
            <small>{'{school_address}'}</small>
          </div>

          {/* Signature in right corner (inside same bg) */}

          <div style={{ marginLeft: "auto" }}>
            <img
              src={"{signature}"}
              alt="signature"
              style={{ height: "25px", objectFit: "contain" }}
            />
          </div>

        </div>

      </div>
    );
  };

  const HorizontalCard3 = ({
    isSelected,
    bgColor,
    headerColor1,
    footerColor,
    logo,
    photo,
    signature,
    name,
    profile_picture,
  }) => {
    return (
      <>
        {/* Header */}
        <style>{`
        :root {
            --primary: #c62828;
            --teal: #2ca6a6;
        }

        body {
            background: #e9ecef;
            font-family: 'Segoe UI', Roboto, Arial, sans-serif;
            padding: 20px 0;
        }

        .id-card {
            width: 85.6mm;
            height: 60mm;
            border-radius: 6px;
            background: #fff;
            box-shadow: 0 4px 14px rgba(0, 0, 0, .25);
            overflow: hidden;
            margin: auto;
            position: relative;
        }

        .card-header {
            height: 11mm;
            padding: 1mm 3mm;
            display: flex;
            align-items: center;
            text-align:start;
            color: #000000;
            border-bottom: 1px solid black;
        }

        .left-header {
            height: 11mm;
            width:45px;
            padding:;
            // display: flex;
            align-items: center;
            // background: #e50b0bff;
            color: #000000;
            // border-bottom: 1px solid black;
        }

        .card-header .logo {
            width: 9mm;
            height: 9mm;
            // border-radius: 50%;
            background: #fff;
            overflow: hidden;
            margin-right: 3mm;
            border: 1px solid #ccc;
        }

        .card-header .logo img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .card-header .school-name {
            font-weight: 700;
            font-size: 3.2mm;
            line-height: 1.2;
        }

        .card-header .school-address {
            font-size: 2.3mm;
            opacity: 0.9;
        }

        .left-panel {
            width: 30%;
            height: calc(90% - 22mm);
            float: left;
            // background: #fafafa;
             margin-top: 11px;
            padding: 3mm 2mm;
            box-sizing: border-box;
            text-align: center;
        }

        .photo-frame {
            background: #2ca6a6;
            padding: 1mm;
            border-radius: 4px;
            margin: auto;
            width: 100%;
            margin-top:-8px;
        }

        .photo-frame img {
            width: 100%;
            height: 30mm;
            object-fit: cover;
            border-radius: 3px;
        }

        .details {
            width: 70%;
            float: right;
            padding: 3mm 4mm;
            box-sizing: border-box;
        }

        .student-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2mm;
        }

        .student-name {
            background: var(--teal);
            color: #fff;
            font-weight: 700;
            font-size: 3.2mm;
            padding: 1mm 2mm;
            border-radius: 3px;
        }

        .id-no {
            font-size: 2.6mm;
            font-weight: 600;
            color: #333;
        }

        .info-row {
            display: flex;
            justify-content: space-between;
            font-size: 2.6mm;
            padding: 0.8mm 0;
            border-bottom: 0.2mm dashed #ddd;
        }

        .info-row:last-child {
            border: none;
        }

        .info-label {
            font-weight: 600;
            color: #333;
        }

        .info-value {
            color: #0b57d0;
        }

        .card-footer {
            position: absolute;
            bottom: -15px;
            left: 0;
            width: 100%;
            border-top: 1px solid black;
            // padding: 1mm 3mm;
            display: flex;
            justify-content: space-between;
            align-items: end;
        }

        .phone-pill {
            background: #fff;
            color: var(--primary);
            font-weight: 700;
            padding: 0.5mm 2mm;
            border-radius: 3mm;
            font-size: 2.4mm;
            border: 1px solid var(--primary);
        }

        .signature {
            text-align: center;
            font-size: 2.2mm;
            color: #333;
            margin-right:20px;
        }

        .signature img {
            width: 18mm;
            height: auto;
            margin-bottom: 1mm;
        }

        @media print {
            body {
                background: none;
                margin: 0;
            }
            .id-card {
                box-shadow: none;
            }
        }
      `}</style>
        <div className="id-card">
          {/* <!-- Header --> */}
          <div className="card-header">
            <div className="left-header">

              <img
                src={"{logo}"}
                alt="logo"
                style={{
                  height: "35px",
                  width: "35px",
                  marginTop: "5px",
                  marginLeft: '10px',
                  // borderRadius: '50%',
                  objectFit: "contain",
                }}
              />

            </div>

            <div style={{ textAlign: 'start' }}>
              <div className="school-name ms-2">{"{school_name}"}</div>
              <div className="ms-2" style={{ flex: 1, textAlign: "start" }}>
                <small>{'{school_address}'}</small>
              </div>
            </div>
          </div>
          <div className="info-row"></div>
          {/* <!-- Left Panel --> */}
          <div className="left-panel">
            <div className="photo-frame">
              <img src={"{profile_picture}"}
                alt="Student Photo" />
            </div>
          </div>
          {/* map */}



          <div className="details">
            <div className="student-row">
              <div className="student-name">
                {type === "student" ? "{student_name}" : "{staff_name}"}
              </div>
              {/* <div className="id-no">
            {type === "student" ? "{registration_no}" : "{staff_id}"}
          </div> */}
            </div>

            {/* Info Rows */}
            {FIELD_MAP[type]?.map((field, idx) => (
              <div className="info-row" key={idx}>
                <div className="info-label">{field.label}</div>
                <div className="info-value">{field.key}</div>
              </div>
            ))}
          </div>
          {/* <div className="hr-row" style={{ border: '1px dotted black' }}>

          </div> */}


          <div className="card-footer">
             <span className="number_area">{"{school_number}"}</span>
            <div>
              <img
                src={"{signature}"}
                alt="signature"
                style={{ height: "25px", objectFit: "contain", marginLeft: '10px', marginBottom: '10px' }}
              />
            </div>

          </div>


        </div>

      </>
    )

  }

  const HorizontalCard4 = ({
    isSelected,
    bgColor,
    headerColor1,
    footerColor,
    logo,
    photo,
    signature,
    name,
    profile_picture,
  }) => {
    return (
      <>
        <style>{`
    .id-card1 {
      width: 336px;  
      height: 212px;
      border-radius: 14px;
      overflow: hidden;
      background: #fff;
      box-shadow: 0 6px 18px rgba(0,0,0,0.25);
      font-family: "Segoe UI", sans-serif;
      display: flex;
      flex-direction: column;
    }

    /* Header - compact version */
    .header1 {
          background: linear-gradient(135deg, #11998e, #38ef7d);
      color: #fff;
      padding: 4px 8px; /* reduced padding */
      display: flex;
      align-items: center;
      gap: 6px;
      min-height: 40px; /* ensures logo fits */
    }
    .header1 img {
      width: 35px;  /* slightly smaller */
      height: 35px;
      object-fit: contain;
      flex-shrink: 0;
    }
  .header-text1 {
    display: flex;
    flex-direction: column;
    line-height: 1.2; /* thoda zyada */
}
    .header-text1 h1 {
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      margin: 0;
      letter-spacing: 0.5px;
    }
   .header-text1 p {
    font-size: 9px;
    margin-top: -18px;
    
}

    /* Body */
    .card-body1 {
      flex: 1;
      display: flex;
      padding: 8px 12px;
    }
    .photo1 {
      width: 30%;
      background: #f0f0f0;
      border: 2px solid  #38ef7d;
      border-radius: 6px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .photo1 img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .info1 {
      width: 65%;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .info1 p {
      margin: 2px 0;
      font-size: 11px;
      color: #333;
      line-height: 1.3;
    }
    .info1 p strong {
      color: #4e54c8;
    }

    /* Footer */
   .footer1 {
    position: relative; /* add this */
    background: linear-gradient(135deg, #11998e, #38ef7d);
    color: #fff;
    text-align: center;
    padding: 2px 0px;
    display:flex;
    justify-content:space-between;

}

.span.number_area {
    margin-left: 16px;
    font-size: 11px;
}
.sign-area1 {
    position: absolute;
    bottom: 6px;
    right: 12px;
    text-align: center;
}

    .sign-line1 {
      width: 80px;
      border-top: 1px solid #000;
      margin: 0 auto 2px auto;
    }
    .sign-text1 {
      font-size: 9px;
      color: black;
    }
        @media print {
            body {
                background: none;
                margin: 0;
            }
            .id-card {
                box-shadow: none;
            }
        }
  `}</style>

        <div className="id-card1">
          {/* Header */}
          <div className="header1">
            <img src={"{logo}"} alt="" />
            <div className="header-text1">
              <h1>{'{school_name}'}</h1>
              <p>{'{school_address}'}</p>
            </div>
          </div>

          {/* Body */}
          <div className="card-body1">
            <div className="photo1">
              <img src={profile_picture || "{profile_picture}"} alt="Student" />
            </div>

            <div className="info1">
              <p>
                <strong style={{ color: ' #11998e' }}>Name:</strong>{" "}
                {type === "student" ? "{student_name}" : "{staff_name}"}
              </p>
              {FIELD_MAP[type]?.map((field, idx) => (
                <p key={idx} >
                  <strong style={{ color: ' #11998e' }}>{field.label}:</strong> {field.key}
                </p>
              ))}
            </div>
          </div>

          {/* Footer */}
          <div className="footer1">
             <span className="number_area">{"{school_number}"}</span>
            <div className="sign-area1">
              <img src={"{signature}"} alt="Signature" style={{ height: '30px', width: '60px', marginLeft: '10px' }} />
              <div className="sign-line1"></div>
              <div className="sign-text1">Principal's Signature</div>
            </div>
          </div>
        </div>
      </>

    );
  };

  const HorizontalCard5 = ({
    isSelected,
    bgColor,
    headerColor1,
    footerColor,
    logo,
    photo,
    signature,
    name,
    profile_picture,
  }) => {
    return (
      <>
        <style>{`
    .id-card2 {
      width: 336px;  
      height: 212px;
      border-radius: 14px;
      overflow: hidden;
      background: #fff;
      box-shadow: 0 6px 18px rgba(0,0,0,0.25);
      font-family: "Segoe UI", sans-serif;
      display: flex;
      flex-direction: column;
    }

    /* Header - compact version */
    .header2 {
         background: linear-gradient(135deg, #4e54c8, #8f94fb);
      color: #fff;
      padding: 4px 8px; /* reduced padding */
      display: flex;
      align-items: center;
      gap: 6px;
      min-height: 40px; /* ensures logo fits */
    }
    .header2 img {
      width: 35px;  /* slightly smaller */
      height: 35px;
      object-fit: contain;
      flex-shrink: 0;
    }
  .header-text2 {
    display: flex;
    flex-direction: column;
    
    line-height: 1.2; /* thoda zyada */
}
    .header-text2 h1 {
      font-size: 14px;
      font-weight: 700;
      text-transform: uppercase;
      margin: 0;
          color: #fff;
      letter-spacing: 0.5px;
    }
   .header-text2 p {
    font-size: 9px;
    margin-top: -18px;
    color:'#fff';
    
}

    /* Body */
    .card-body2 {
      flex: 1;
      display: flex;
      padding: 8px 12px;
    }
    .photo2 {
      width: 30%;
      background: #f0f0f0;
      border: 2px solid  #4e54c8;
      border-radius: 6px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .photo2 img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .info2 {
      width: 65%;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .info2 p {
      margin: 2px 0;
      font-size: 11px;
      color: #333;
      line-height: 1.3;
    }
    .info2 p strong {
      color: #010101;
    }

    /* Footer */
   .footer2 {
    position: relative; /* add this */
    background: linear-gradient(135deg, #4e54c8, #8f94fb);
    color: #fff;
    text-align: center;
    padding: 2px 0px;
    display:flex;
    justify-content:space-between;
}

span.number_area {
    margin-left: 16px;
    font-size: 11px;
}
.sign-area2 {
    position: absolute;
    bottom: 6px;
    right: 12px;
    text-align: center;
}

    .sign-line2 {
      width: 80px;
      border-top: 1px solid #000;
      margin: 0 auto 2px auto;
    }
    .sign-text2 {
      font-size: 9px;
      color: black;
    }
        @media print {
            body {
                background: none;
                margin: 0;
            }
            .id-card {
                box-shadow: none;
            }
        }
  `}</style>

        <div className="id-card2">
          {/* Header */}
          <div className="header2">
            <img src={"{logo}"} alt="Logo" />
            <div className="header-text2">
              <h1>{'{school_name}'}</h1>
              <p>{'{school_address}'}</p>
            </div>
          </div>

          {/* Body */}
          <div className="card-body2">
            <div className="photo2">
              <img src={profile_picture || "{profile_picture}"} alt="Student" />
            </div>

            <div className="info2">
              <p>
                <strong style={{ color: ' #4e54c8' }}>Name:</strong>{" "}
                {type === "student" ? "{student_name}" : "{staff_name}"}
              </p>
              {FIELD_MAP[type]?.map((field, idx) => (
                <p key={idx} >
                  <strong style={{ color: '#4e54c8' }}>{field.label}:</strong> {field.key}
                </p>
              ))}
            </div>
          </div>
{/* {"{school_number}"} */}
          {/* Footer */}
          <div className="footer2">
            <span className="number_area">{"{school_number}"}</span>
           
            
            <div className="sign-area2">
              <img src={"{signature}"} alt="Signature" style={{ height: '30px', width: '60px', marginLeft: '10px' }} />
              <div className="sign-line2"></div>
              <div className="sign-text2">Principal's Signature</div>
            </div>
          </div>
        </div>
      </>

    );
  };

  const HorizontalCard6 = ({
    logo,
    signature,
    profile_picture,


  }) => {
    return (
      <>
        <style>{`
        .id-card3 {
          width: 336px;  /* CR80 */
          height: 212px;
          border-radius: 14px;
          overflow: hidden;
          background: linear-gradient(135deg,#e8e0f1 0%,#d9d0e7 100%);
          background-size: cover;
          font-family: "Segoe UI", sans-serif;
          display: flex;
          flex-direction: row;
          padding: 12px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.25);
          position: relative;
        }
        .left-side {
          flex: 2;
          display: flex;
          flex-direction: column;
        }
        .top-box {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 6px;
          padding:5px;
          background-color: rgb(46, 46, 93);
          border-radius: 4px;
        }
              .info3 {
      width: 65%;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .info3 p {
      margin: 2px 0;
      font-size: 9px;
      color: #333;
      line-height: 1.3;
    }
    .info3 p strong {
      color: #010101;
    }
        .top-box img {
          width: 40px;
          height: 40px;
          object-fit: contain;
        }
        .school-name {
          font-weight: 700;
          font-size: 10px;
          color: #fff;
        }
        .school-address {
          font-size: 8px;
          color: #fff;
        }
        .field-row {
          margin-bottom: 4px;
          font-size: 11px;
          color: #333;
        }
        .field-row span {
          font-weight: 600;
        }
        .right-side {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: flex-start;
        }
        .photo-wrap {
          width: 80px;
          height: 110px;
          border: 2px solid #2E2E5D;
          border-radius: 6px;
          overflow: hidden;
          background-color: #fff;
        }
        .photo-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .footer-shape {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 60%;
          height: 16px;
          background-color: #2E2E5D;
          border-top-right-radius: 14px;
        }
        .signature-area {
          position: absolute;
          bottom: 4px;
          right: 12px;
          text-align: center;
        }
        .signature-area img {
          height: 30px;
          width: 60px;
          display: block;
          margin-bottom: 2px;
        }
        .signature-text {
          font-size: 9px;
          color: #000;
        }
          .school_phone{
          font-size:10px;
          margin-left:15px;
          position: relative;
          top: -4px;
          color: white;
          }
      `}</style>

        <div className="id-card3">
          {/* Left side with school info & fields */}
          <div className="left-side">
            <div className="top-box">
              <img src={"{logo}"} alt="Logo" />
              <div>
                <div className="school-name">{'{school_name}'}</div>
                <div className="school-address">{'{school_address}'}</div>
              </div>
            </div>

            {/* Dynamic fields */}
            <div className="info3">
              <p>
                <strong style={{ color: ' rgb(46, 46, 93)' }}>Name:</strong>{" "}
                {type === "student" ? "{student_name}" : "{staff_name}"}
              </p>
              {FIELD_MAP[type]?.map((field, idx) => (
                <p key={idx} >
                  <strong style={{ color: 'rgb(46, 46, 93)' }}>{field.label}:</strong> {field.key}
                </p>
              ))}
            </div>
          </div>

          {/* Right side: Photo */}
          <div className="right-side">
            <div className="photo-wrap">
              <img
                src={profile_picture || "{profile_picture}"}
                alt="Student"
              />
            </div>
          </div>

          {/* Footer shape & signature */}
          <div className="footer-shape"><span className="school_phone">{"{school_number}"}</span></div>

          <div className="signature-area">
            <img src={"{signature}"} alt="Signature" />
            <div className="signature-text">Principal's Signature</div>
          </div>
        </div>
      </>
    );
  };



  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="content-wrapper">
            <div className="container-fluid py-4">
              <div className="card p-3">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h4 className="mb-0">Choose ID Cards</h4>
                  <Link to={"/idcard"} className="btn btn-sm btn-outline-primary">
                    <i className="bi bi-arrow-left-circle me-1"></i> Back
                  </Link>
                </div>

                {/* Step 1: Select Type */}
                <div className="mb-3">
                  <label className="form-label fw-bold">Select Card Type</label>
                  <select
                    className="form-select"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                  >
                    <option value="">-- Select --</option>
                    <option value="student">Student</option>
                    <option value="teacher">Teacher / Staff</option>
                  </select>
                </div>

                {/* Step 2: Upload Logo & Signature */}
                {type && (
                  <>
                    <div className="row my-3">
                      <div className="col-md-4">
                        <label className="form-label fw-bold">Upload Logo</label>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={(e) => setLogo(e.target.files[0])}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label fw-bold">Upload Signature</label>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={(e) => setSignature(e.target.files[0])}
                        />
                      </div>
                    </div>

                    {/* Step 3: Card Preview & Selection */}
                    <div className="row mt-4">
                      {templates.map((tpl) => {
                        const isSelected = selectedCard === tpl.id;
                        return (
                          <div
                            key={tpl.id}
                            className={`col-md-3 ${tpl.orientation === "horizontal" ? 'col-md-4 ' : ''} mb-4 d-flex flex-column align-items-center`}
                          >
                            <div
                              ref={(el) => (cardRefs.current[tpl.id] = el)} // ✅ ref sirf card pe lagao
                            >
                              {tpl.orientation === "vertical" && tpl.type === "v1" && (
                                <VerticalCard
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor={headerColor}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {tpl.orientation === "vertical" && tpl.type === "v3" && (
                                <VerticalCard3
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor={headerColor}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {tpl.orientation === "vertical" && tpl.type === "v2" && (
                                <VerticalCard2
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor1={headerColor1}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {/* {tpl.orientation === "vertical" && tpl.type === "v4" && (
                                <VerticalCard4
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor1={headerColor1}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )} */}
                              {tpl.orientation === "vertical" && tpl.type === "v6" && (
                                <VerticalCard6
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor={headerColor}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {tpl.orientation === "vertical" && tpl.type === "v7" && (
                                <VerticalCard7
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor={headerColor}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {tpl.orientation === "vertical" && tpl.type === "v8" && (
                                <VerticalCard8
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor={headerColor}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {tpl.orientation === "vertical" && tpl.type === "v9" && (
                                <VerticalCard9
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor={headerColor}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {tpl.orientation === "vertical" && tpl.type === "v10" && (
                                <VerticalCardPro
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor={headerColor}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {/* {tpl.orientation === "vertical" && tpl.type === "v7" && (
                                <VerticalCard7
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor={headerColor}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )} */}
                              {/* {tpl.orientation === "vertical" && tpl.type === "v8" && (
                                <VerticalCard8
                                   {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor={headerColor}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )} */}
                              {tpl.orientation === "horizontal" && tpl.type === "h1" && (
                                <HorizontalCard
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor={headerColor}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {tpl.orientation === "horizontal" && tpl.type === "h2" && (
                                <HorizontalCard2
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor1={headerColor1}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {tpl.orientation === "horizontal" && tpl.type === "h3" && (
                                <HorizontalCard3
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor1={headerColor1}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {tpl.orientation === "horizontal" && tpl.type === "h4" && (
                                <HorizontalCard4
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor1={headerColor1}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                              {tpl.orientation === "horizontal" && tpl.type === "h5" && (
                                <HorizontalCard5
                                  {...tpl}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor1={headerColor1}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}

                              {tpl.orientation === "horizontal" && tpl.type === "h6" && (
                                <HorizontalCard6
                                  {...tpl}
                                  // type={tpl.type}          // ← Add this
                                  // FIELD_MAP={FIELD_MAP}
                                  isSelected={isSelected}
                                  bgColor={bgColor}
                                  headerColor1={headerColor1}
                                  footerColor={footerColor}
                                  logo={logo && URL.createObjectURL(logo)}
                                  photo={photo}
                                  signature={signature && URL.createObjectURL(signature)}
                                  name={name}
                                />
                              )}
                            </div>

                            {/* ✅ Radio card ke bahar rakha hai, ref me include nahi hoga */}
                            <div className="mt-2">
                              <input
                                type="radio"
                                name="selectedCard"
                                value={tpl.id}
                                checked={selectedCard === tpl.id}
                                onChange={() => {
                                  setSelectedCard(tpl.id);
                                  localStorage.setItem(`selectedCard_${type}`, tpl.id);
                                }}
                              />
                              <label className="ms-1">{tpl.name}</label>
                            </div>
                          </div>

                        );
                      })}
                    </div>


                    {/* Submit Button */}
                    <button
                      type="submit"
                      className="btn btn-primary px-5 btn-sm"
                      disabled={loading}  // Disable the button while loading
                      onClick={handleSubmit}
                      style={{ width: 200 }}
                    >
                      {loading ? (
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      ) : (
                        'Submit'
                      )}
                      {loading ? ' Submitting...' : ''}
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IDCardGenerator;
